'use client';
import { createPreset } from '../createPreset';
import { subtitle2ClassNames, useSubtitle2Styles } from './useSubtitle2Styles.styles';
/**
 * Text preset component for the Subtitle2 typography variant
 */ export const Subtitle2 = createPreset({
    useStyles: useSubtitle2Styles,
    className: subtitle2ClassNames.root,
    displayName: 'Subtitle2'
});
